import { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import aboutImage from "../../Assets/about-me-image.jpg";

function About() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <>
      <Container fluid className="section about-section">
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col
              style={{
                justifyContent: "center",
                paddingTop: "30px",
              }}
            >
              <h1 style={{ paddingBottom: "20px" }}>
                About Me
              </h1>
              I'm just a gamer who wants to see more RTS games.
              <br></br>
              Born and raised in Toronto.
              <br></br>
              <a href="mailto:contact@hotkeyclicker.com">Contact Me</a>
            </Col>
            <Col>
              <img src={aboutImage} alt="about" className="img-fluid" />
            </Col>
          </Row>
          
        </Container>
      </Container>
      <div class="push"></div>
    </>
  );
}

export default About;
